import { jsx } from 'react/jsx-runtime';

const SvgEmail = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.5 3h-14C.673 3 0 3.673 0 4.5v8c0 .827.673 1.5 1.5 1.5h14c.827 0 1.5-.673 1.5-1.5v-8c0-.827-.673-1.5-1.5-1.5Zm-.263 1L8.5 9.838 1.763 4h13.474ZM1 12.5a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V4.661l-7.173 6.216a.5.5 0 0 1-.654 0L1 4.661V12.5Z",
        fill: "#445058"
      }
    )
  }
);

export { SvgEmail as default };
//# sourceMappingURL=Email.js.map
